<template>
  <transition name="slide">
    <b-row>
      <b-col cols="12">
        
        <b-card v-if="registro_no_encontrado">
          <div slot="header">
            <strong>Registro no encontrado</strong>
          </div>
        </b-card>
        
        <b-card v-else>
        
          <div slot="header"><i class="fa fa-file"></i> Diseño Reportes</div>
          
          <div>
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group label="Titulo:" label-for="titulo">
                  <b-form-input
                    id="titulo"
                    v-model="model.titulo_reporte"
                    placeholder="Nombre o Título del Reporte"
                    required
                    @change="comprobar()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Descripcion:" label-for="desc">
                  <b-form-input
                    id="desc"
                    v-model="model.descripcion"
                    placeholder="Descripción de Reporte"
                    required
                    @change="comprobar()"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group label="Tipo:" label-for="tipo">
                  <b-form-select v-model="model.tipo" @input="comprobar()">
                    <b-form-select-option-group label="Cierre Mensual">
                      <b-form-select-option value="1"
                        >Mes Seleccinado</b-form-select-option
                      >
                      <b-form-select-option value="2"
                        >Mes Seleccionado vs Anterior</b-form-select-option
                      >
                    </b-form-select-option-group>
                    <b-form-select-option-group label="Cierres Anual">
                      <b-form-select-option value="3"
                        >Año Seleccionado</b-form-select-option
                      >
                      <b-form-select-option value="4"
                        >Año Seleccionado vs Anterior</b-form-select-option
                      >
                    </b-form-select-option-group>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="4" md="2" v-show="!nuevo">
                <b-form-group label="Activo:">
                  <b-form-select v-model="model.activo">
                    <b-form-select-option value="1">Si</b-form-select-option>
                    <b-form-select-option value="2">No</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <em>Contenido:</em>
            <br />
            <b-row>
              <b-col>
                <b-button
                  v-b-tooltip.hover
                  title="Agregar fila de nivel 1"
                  class="btn-sm"
                  variant="outline-success"
                  @click="addRow()"
                >
                  <i class="fa fa-plus" /> Agregar fila
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="table-responsive">
                <br />
                <table class="table">
                  <draggable
                    class="col-sm-12"
                    handle=".handle"
                    v-model="model.filas"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                  >
                    <transition-group
                      type="transition"
                      :name="!drag ? 'flip-list' : null"
                    >
                      <tbody
                        v-for="(fila, indice) in model.filas"
                        :key="indice+'-'+fila.grupo"
                        style="display: block"
                      >
                        <tr>
                          <td style="width:60px">
                            <i class="fa fa-align-justify mt-3 handle move">
                              {{ indice + 1 }}</i
                            >
                          </td>
                          <td style="width:80px" :style="margen(indice)">
                            <b-button
                              variant="outline-success"
                              @click="addItemOperation(indice)"
                              class="mt-4"
                              v-show="activar_seleccion && (fila.detalles.length || (fila.operaciones && fila.operaciones.length)) && indice != index_select_operacion"
                              v-b-tooltip.hover
                              title="Presiona para seleccionar fila"
                              ><i class="fa fa-check"></i>
                            </b-button>
                          </td>
                          <td>
                            <b-form-group label="Nivel:">
                              <b-form-select v-model="fila.grupo">
                                <b-form-select-option value="1">1</b-form-select-option>
                                <b-form-select-option value="2">2</b-form-select-option>
                                <b-form-select-option value="3">3</b-form-select-option>
                                <b-form-select-option value="4">4</b-form-select-option>
                              </b-form-select>
                            </b-form-group>
                          </td>
                          <td>
                            <b-form-group label="Tipo:">
                              <b-form-select v-model="fila.tipo">
                                <b-form-select-option value="1">Título</b-form-select-option>
                                <b-form-select-option value="4">Cuenta(s) Origen delvalor</b-form-select-option>
                                <b-form-select-option value="2">Operación</b-form-select-option>
                                <b-form-select-option value="3">Linea en blanco</b-form-select-option>
                              </b-form-select>
                            </b-form-group>
                          </td>
                          <td style="width:280px">
                            <b-form-group
                              label="Texto a mostrar:"
                              v-show="fila.tipo !== '3'"
                            >
                              <b-form-input
                                style="width: 280px"
                                v-model="fila.texto"
                                placeholder="Ingrese texto a mostrar"
                                required
                                :style="fila.estilo"
                              ></b-form-input>
                            </b-form-group>
                          </td>
                          <td>
                            <b-form-group
                              label="Formato/estilo:"
                              v-show="fila.tipo !== '3'"
                            >
                              <b-button-toolbar>
                                <b-button-group size="sm" v-model="fila.estilo">
                                  <b-button
                                    @click="setStyle(indice, 'font-weight: bold;')"
                                    :class="{'btn-success': isActive(indice, 'bold')}"
                                    v-b-tooltip.hover
                                    title="Negrita"
                                  >
                                    <strong>N</strong>
                                  </b-button>
                                  <b-button
                                    @click="setStyle(indice, 'font-style: italic;')"
                                    :class="{'btn-success': isActive(indice, 'italic')}"
                                    v-b-tooltip.hover
                                    title="Cursiva"
                                  >
                                    <strong><em>K</em></strong>
                                  </b-button>
                                  <b-button
                                    @click="setStyle(indice,'text-decoration-line: underline;')"
                                    :class="{'btn-success': isActive(indice,'underline')}"
                                    v-b-tooltip.hover
                                    title="Subrayado"
                                  >
                                    <strong><u>S</u></strong>
                                  </b-button>
                                  <b-button
                                    v-show="isUnderline(indice)"
                                    @click="setStyle(indice,'text-decoration-style: double;')"
                                    :class="{'btn-success': isActive(indice, 'double')}"
                                    v-b-tooltip.hover
                                    title="Doble Subrayado"
                                  >
                                    <strong
                                      ><span
                                        style="
                                          text-decoration-line: underline;
                                          text-decoration-style: double;
                                        "
                                        >DS</span
                                      ></strong
                                    >
                                  </b-button>
                                </b-button-group>
                              </b-button-toolbar>
                            </b-form-group>
                          </td>
                          <td>
                            <b-button
                              v-show="fila.tipo == 4"
                              class="pull-right btn-sm mt-4"
                              variant="outline-primary"
                              @click="addCuenta(indice)"
                            >
                              <i class="fa fa-plus" /> Cuenta
                            </b-button>
                            <b-button
                              v-show="fila.tipo == 2 && indice == index_select_operacion"
                              class="pull-right btn-sm mt-4 btn-pill"
                              variant="outline-danger"
                              @click="cancelSelectRows()"
                              v-b-tooltip.hover
                              title="Cancelar Selección de filas"
                            >
                              <i class="fa fa-times" /> Cancelar
                            </b-button>
                            <b-button
                              v-show="fila.tipo == 2 && indice !== index_select_operacion"
                              class="pull-right btn-sm mt-4 btn-pill"
                              variant="outline-info"
                              @click="selectRows(indice)"
                              v-b-tooltip.hover
                              title="Seleccionar filas"
                            >
                              <i class="fa fa-check" /> Selec Filas
                            </b-button>
                          </td>
                          <td>
                            <i
                              class="fa fa-trash mt-4 close text-danger"
                              v-b-tooltip.hover
                              title="Quitar Fila"
                              @click="removeAt(indice)"
                            ></i>
                          </td>
                        </tr>
                        <tr
                          v-show="fila.tipo == 4"
                          v-for="(det, ind) in fila.detalles"
                          :key="`det-${ind}`"
                        >
                          <td colspan="2"></td>
                          <td colspan="3">
                            <multiselect
                              :clear="true"
                              v-model="det.cuentasearch"
                              placeholder="Buscar cuenta..."
                              :options="cuentas"
                              :custom-label="labelSelectMuc"
                              selectLabel="Presione enter para seleccinar"
                              deselectLabel="Presione enter para remover"
                              selectedLabel="Seleccionado"
                              label=""
                              track-by="id"
                              :searchable="true"
                              :loading="false"
                              :internal-search="false"
                              :options-limit="15"
                              :limit="10"
                              :allow-empty="true"
                              open-direction="bottom"
                              @search-change="getCuentas($event)"
                              @select="cuenta_seleccionada($event, indice, ind)"
                            >
                              <template slot="noResult">
                                No hay resultados</template
                              >
                              <template slot="noOptions">
                                Buscar por número o nombre de cuenta</template
                              >
                            </multiselect>
                          </td>
                          <td>
                            <i
                              class="fa fa-trash close ml-2 text-danger"
                              v-b-tooltip.hover
                              title="Quitar Cuenta"
                              @click="removeDet(indice, ind)"
                            ></i>
                          </td>
                        </tr>
                        <tr v-show="fila.tipo == 2">
                          <td colspan="3"></td>
                          <td>
                            <span
                              v-for="(ope, indx) in fila.operaciones"
                              :key="`oper-${indx}`"
                            >
                              <span v-show="ope.fila">
                                Fila {{ ope.fila }}
                                <b-button
                                  v-show="ope.ope"
                                  class="btn-sm"
                                  @click="changeOperador(indx, indice)"
                                  ><strong>{{ ope.ope }}</strong></b-button
                                >
                              </span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </transition-group>
                  </draggable>
                  <tr>
                    <td colspan="6">
                      <div style="min-height: 120px"></div>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </div>

          <b-navbar class="fixed-bottom" type="dark" variant="dark">
            <div class="mx-auto">
              <button
                :disabled="no_guardar"
                class="btn btn-success text-white"
                @click="guardar()"
              >
                <i class="fa fa-dot-circle-o"></i> Guardar
              </button>
              <router-link
                class="btn btn-danger text-white ml-2"
                :to="'/config/reportes'"
              >
                <i class="fa fa-ban" /> Cancelar
              </router-link>
            </div>
          </b-navbar>
        
        </b-card>
      
      </b-col>
    </b-row>
  </transition>
</template>

<script>
/*Array.prototype.insert = function(index, item) {
  this.splice(index, 0, item);
};*/
import draggable from "vuedraggable";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  components: { draggable, Multiselect },
  name: "configreportes",
  created() {
    this.cargar();
  },
  data: () => {
    return {
      registro_no_encontrado: false,
      index_select_operacion: "",
      no_guardar: true,
      drag: false,
      nuevo: true,
      cuentas: [],
      ruta_guardar:'',
      model: {
        titulo_reporte: "",
        descripcion: "",
        tipo: undefined,
        activo: 1,
        filas: [
          {
            orden: 1,
            grupo: 1,
            tipo: 1,
            texto: "",
            estilo: "",
            detalles: [],
            operaciones: []
          }
        ]
      },
      activar_seleccion: false
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },

  methods: {
    async cargar() {
          if (this.$route.name == "configreportesform"){
          this.registro_no_encontrado = false;
          this.ruta_guardar = "/api/configreportes/crear"
      }
      else if (this.$route.params.id != null) {
        this.ruta_guardar = "/api/configreportes/actualizar"
        this.nuevo =false;
        try {
          let response = await axios.get(
            "/api/configreportes/" + this.$route.params.id
          );
          if (response.status == 200) {
            let { data } = response.data;
            if (!data) {
              this.registro_no_encontrado = true;
              return;
            }
            this.model = data;
            this.model.filas.forEach(fila => {
              let operaciones = [];

              if (typeof fila.operaciones == "string") {
                operaciones = [];
                let tempstr = fila.operaciones.split(",");

                tempstr.forEach((t, indice) => {
                  let obj = {};
                  if (!isNaN(parseInt(t))) {
                    obj.fila = t;
                    obj.ope = "+";
                  } else {
                    if (operaciones.length > 0) {
                      let indx = indice - 1;
                      if (operaciones[indx])
                        operaciones[indx].ope = t.replace(
                          new RegExp("'", "g"),
                          ""
                        );
                    }
                  }
                  if (Object.entries(obj).length > 0) operaciones.push(obj);
                });
                fila.operaciones = operaciones;
              }

              fila.detalles.forEach(det => {
                let cuenta = det.cuenta_contable;
                let res = axios
                  .post("/api/catalogos/muc/busquedactamuclite", {
                    cuenta,
                    tipo: "Mayor"
                  })
                  .then(res => {
                    let suggestions = res.data.data;
                    this.cuentas = suggestions;
                    det.cuentasearch = this.cuentas.find(
                      option => option.cuenta === det.cuenta_contable
                    );
                    this.cuentas = [];
                  });
              });
            });
          } else this.registro_no_encontrado = true;
        } catch (error) {
          console.log(error);
        }
      } else this.registro_no_encontrado = true;
    },
    checkMove() {
      let array = this.model.filas.map((fila, index) => {
        fila.orden = index + 1;
        return fila;
      });
      this.model.filas = [];
      this.model.filas = array;
    },
    margen(indice) {
      let ancho = parseInt(this.model.filas[indice].grupo) * 4;
      return { width: `${ancho}%` };
    },
    labelSelectMuc({ cuenta, nombre }) {return cuenta + " " + this.text_truncate(nombre, 35);},
    /*filasNivel(valor) {
      return this.model.filas.filter(fila => parseInt(fila.grupo) == valor);
    },*/
    isActive(indice, valor) {return this.model.filas[indice].estilo.includes(valor);},
    isUnderline(indice) {return this.model.filas[indice].estilo.includes("underline");},
    removeAt(idx) {this.model.filas.splice(idx, 1);},
    removeDet(indice, idx) {this.model.filas[indice].detalles.splice(idx, 1);},
    addRow() {
      let fila = {};
      fila.orden = this.model.filas.length + 1;
      fila.titulo = "";
      fila.grupo = 1;
      fila.estilo = "";
      fila.detalles = [];
      fila.operaciones = [];
      this.checkMove();
      this.model.filas.push(fila);
    },
    addCuenta(indice) {this.model.filas[indice].detalles.push({ cuenta_contable: "" });},
    setStyle(indice, valor) {
      this.model.filas[indice].estilo = this.model.filas[
        indice
      ].estilo.includes(`${valor}`)
        ? this.model.filas[indice].estilo.replace(`${valor}`, "")
        : this.model.filas[indice].estilo + `${valor}`;
    },
    cuenta_seleccionada(e, index, index_det) {
      this.model.filas[index].detalles[index_det].cuenta_contable = "";
      this.model.filas[index].detalles[index_det].cuenta_contable = e.cuenta;
      this.model.filas[index].detalles[index_det].cuentasearch = {};
    },
    text_truncate(str, length, ending) {
      if (ending == null) {
        ending = "...";
      }
      if (typeof str != "undefined") {
        if (str.length > length) {
          return str.substring(0, length - ending.length) + ending;
        } else {
          return str;
        }
      }
    },
    async getCuentas(cuenta) {
      const res = await axios.post("/api/catalogos/muc/busquedactamuclite", {
        cuenta,
        tipo: "Mayor"
      });
      const suggestions = res.data.data;
      this.cuentas = suggestions;
    },
    cancelSelectRows() {
      this.activar_seleccion = false;
      this.index_select_operacion = "";
    },
    selectRows(index) {
      this.index_select_operacion = index;
      this.activar_seleccion = true;
    },
    changeOperador(index, seleccionado) {
      this.index_select_operacion = seleccionado;
      this.model.filas[this.index_select_operacion].operaciones[index].ope =this.model.filas[this.index_select_operacion].operaciones[index].ope =="-"? "+": "-";
    },
    addItemOperation(index) {
      let no_encontrado = true;
      let indice = parseInt(index) + 1;
      this.model.filas[this.index_select_operacion].operaciones.forEach(
        (ope, idx) => {
          if (indice == ope.fila) {
            no_encontrado = false;
            this.model.filas[this.index_select_operacion].operaciones.splice(
              idx,
              1
            );
            return;
          }
        }
      );
      if (no_encontrado) {
        let obj = {};
        obj.fila = parseInt(index) + 1;
        obj.ope = "+";
        this.model.filas[this.index_select_operacion].operaciones.push(obj);
      }
    },
    async guardar(){
     let resp = await axios.post(this.ruta_guardar, {
        model: this.model
      });
      if (resp.data.status == "ok") {
        toastr["success"]("Guardado Correctamente");
        this.$router.push("/comprobantes-diario");
      }
    },
    comprobar(){
      this.no_guardar =true;
      if(this.model.titulo_reporte && this.model.titulo_reporte !==''
        && this.model.descripcion && this.model.descripcion !==''
        && this.model.tipo !== null && this.model.filas && this.model.filas.length >0
       )
         this.no_guardar =false;
    }
  }
};
</script>

<style scoped>
.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}
.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #d8e7d991;
}
.move {
  cursor: move;
}
</style>
